import React from "react";
import useAuthEffect from "../../../hook/useAuthEffect";
import { fetchMemories } from "../../../redux/ducks/memory";
import { useSelector, useDispatch } from "react-redux";

const MemorySelect = props => {
    const dispatch = useDispatch();
    const memories = useSelector(state => state.memory.memories) || [];

    useAuthEffect(() => {
        dispatch(fetchMemories());
    }, []);

    return (
        <select name={props.name} className={"select select--primary " + props.className} onChange={props.onChange}>

            <option selected disabled></option>
            {
                Object.keys(memories).map(memoryID => {
                    const memory = memories[memoryID];
                    return <option value={memoryID}>{memory.name}</option>
                })
            }
        </select>
    )
}

export default MemorySelect;